


































import {mixins} from "vue-class-component";
import {CommonMixin} from "../../../../../../shared/services/mixin";
import {Component, Prop, PropSync} from "vue-property-decorator";
import {ExpenseCustomer} from "@/interfaces/entity";
import {ReceiptCustomerStore} from "@/modules/receiptsexpenses/receiptcustomer/store";
import {ClearingDebtType, ExpensePaymentType} from '@/enums/type';
import LadingStatusLabel from "@/shared/components/LadingStatusLabel/index.vue";
import moment from 'moment';
import {FORMAT_DATE_PICKER} from "@/shared/constant";
import LadingPaymentTypeLabel from "../../../../../ladings/List/components/PaymentTypeLabel.vue";

const columns = [
    {
        title: "STT",
        dataIndex: "stt",
        key: "stt",
        width: 80
    },
    {
      title: "Ngày phát hành",
      dataIndex: "billLading.ladingDate",
      key: "ladingDate",
      width: 150,
      ellipsis: true,
      scopedSlots: {customRender: 'ladingDate'}
    },
    {
        title: "Mã vận đơn",
        dataIndex: "billLading.ladingCode",
        key: "ladingCode",
        width: 150,
        ellipsis: true
    },
    {
        title: "Thu hộ COD",
        dataIndex: "billLading.codMoney",
        key: "codMoney",
        scopedSlots: {customRender: 'codMoney'},
        width: 150,
        ellipsis: true
    },
    {
        title: "Cước cấn trừ",
        dataIndex: "clearingMoney",
        key: "clearingMoney",
        scopedSlots: {customRender: 'clearingMoney'},
        width: 150,
        ellipsis: true
    },
    {
        title: "HT thanh toán",
        dataIndex: "billLading.payment",
        key: "payment",
        scopedSlots: {customRender: 'payment'},
        width: 150,
        ellipsis: true
    },
    {
        title: "Trả tiền người gửi",
        dataIndex: "money",
        key: "money",
        scopedSlots: {customRender: 'money'},
        width: 150,
        ellipsis: true
    },
];
@Component({
    name: "ExpenseDebtCustomerTable",
    components: {LadingPaymentTypeLabel, LadingStatusLabel}
})
export default class extends mixins(CommonMixin) {
    @Prop() readonly expenseCustomers!: Array<ExpenseCustomer>;
    @PropSync('debtIds', {default: () => [], type: Array}) syncDebtIds!: number[];
    @Prop() readonly clearingType!: number;
    columns = columns;
    moment = moment;
    FormatDate = FORMAT_DATE_PICKER;
    ClearingDebtType = ClearingDebtType

    clearingMoneyExpense(record) {
        return record.clearingType !== ClearingDebtType.Yes ? (record.clearingMoney ? record.clearingMoney : 0) : 0
    }

    codMoney(record) {
        return record.billLading.codMoney ? record.billLading.codMoney : 0
    }

    onSelectedIdsChange(selectedIds: any) {
        this.syncDebtIds = selectedIds;
    }
}
